var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1305.02 285.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8068ab;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M465.06,80.38h22.4l23.76,75.52c3.09,9.85,5.79,20.86,5.79,20.86,0,0,2.7-10.82,5.22-20.86l19.7-75.52h23.95l19.7,75.52c2.7,10.04,5.02,20.86,5.02,20.86,0,0,2.9-10.82,5.99-20.86l23.76-75.52h22.4l-39.98,125.54h-23.76l-20.09-72.62c-2.9-10.82-5.02-24.72-5.02-24.72,0,0-2.12,13.91-5.02,24.72l-20.09,72.62h-23.95l-39.79-125.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M691.8,80.38h21.24l56.4,125.15h-22.79l-9.85-21.63h-68.76l-9.85,21.63h-22.79l56.4-125.15ZM729.08,166.14l-14.29-32.45c-5.41-12.36-12.36-29.16-12.36-29.16,0,0-6.76,16.61-12.36,29.16l-14.29,32.45h53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M908.31,80.38h49.06c40.75,0,66.44,28.39,66.44,62.58s-25.69,62.58-66.44,62.58h-49.06v-125.15ZM956.41,186.22c26.46,0,44.04-18.35,44.04-43.26s-17.58-43.26-44.04-43.26h-25.69v86.53h25.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1087.94,80.38h21.24l56.4,125.15h-22.79l-9.85-21.63h-68.76l-9.85,21.63h-22.79l56.4-125.15ZM1125.21,166.14l-14.29-32.45c-5.41-12.36-12.36-29.16-12.36-29.16,0,0-6.76,16.61-12.36,29.16l-14.29,32.45h53.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1173.3,142.96c0-35.73,28-64.51,65.86-64.51s65.86,28.78,65.86,64.51-28.01,64.51-65.86,64.51-65.86-28.58-65.86-64.51ZM1281.65,142.96c0-24.14-18.15-44.23-42.3-44.23s-42.68,20.09-42.68,44.23,18.16,44.23,42.68,44.23,42.3-20.09,42.3-44.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "892.3 80.38 864.86 80.38 839.8 114.26 853.44 133.16 892.3 80.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "917.29 238.44 775.79 46.71 748.68 46.71 819.86 142.58 773.7 205.54 800.56 205.54 832.99 161.69 890.19 238.44 917.29 238.44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.53,207.11l-13.56-7.83v-98.26l-31.99,18.47v98.26l13.56,7.83,31.99-18.47ZM325.65,18.47v180.81l-85.84,49.56-17.71-10.22-31.99,18.47,49.7,28.69,117.83-68.03V0l-31.99,18.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.66 53.85 203.67 72.32 203.67 199.28 117.83 248.84 31.99 199.28 31.99 18.47 0 0 0 217.75 117.83 285.78 235.66 217.75 235.66 53.85"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.f4a27b907e34145a39677f01cd5b0537.svg";
export { ForwardRef as ReactComponent };